import { getFeatureFlagConfig } from '@shell-b2c/http-frontend/dist/src/components/core/config';
import { COMARCH_MIGRATION_NOTIFICATION } from '../features/app/notifications';
import { showNotification } from '../features/notification/actions';
import { makeSelectQueryCountry, makeSelectQuery, makeSelectIsMotoristApp } from '../features/app/selectors';
import { makeSelectIsIOS, makeSelectIsAndroid } from '../features/browser/selectors';
import { setSpinner, sendAdobeAnalyticsEvent } from '../features/app/actions';
import adobeAnalyticTags from './adobeAnalyticTags';
import selectSettingsDomain, {
  makeSelectSettingsRedirect,
  makeSelectSettingsDownloadIOSUrl,
  makeSelectSettingsDownloadAndroidUrl,
} from '../features/settings/selectors';
import browserHistory from '../router/history';

/**
 * Returns true if `is_comarch_enable` is set for the current market using featureFlagSettings.
*/
export async function isComarchMigrationEnabled(getState) {
  let countryConfig = selectSettingsDomain()(getState())?.featureFlagSettings;
  if (!countryConfig) {
    const country = makeSelectQueryCountry()(getState());
    const allFeatureFlags = await getFeatureFlagConfig();
    countryConfig = allFeatureFlags?.[country] ?? {};
  }
  return Boolean(countryConfig?.is_comarch_enable);
}

/**
 * Redirects comarch markets (HU, DE, AT):
 * - Fireblade app + iOS  → iOS download URL
 * - Fireblade app + Android → Android download URL
 * - Otherwise → configured redirect URL
 */
export const redirectToComarchURL = async (getState, dispatch) => {
  dispatch(setSpinner(true));
  const isComarch = await isComarchMigrationEnabled(getState);
  const isFirebladeApp = makeSelectIsMotoristApp()(getState());
  const isIOSDevice = makeSelectIsIOS()(getState());
  const isAndroidDevice = makeSelectIsAndroid()(getState());
  const iosDownloadURL = makeSelectSettingsDownloadIOSUrl()(getState());
  const androidURL = makeSelectSettingsDownloadAndroidUrl()(getState());
  const query = makeSelectQuery()(getState());
  const redirectURL = makeSelectSettingsRedirect()(getState()).replace(
    '{{lang}}',
    query?.market?.split('-')[0]
  );
  if (isComarch && isFirebladeApp) {
    if (isIOSDevice) {
      browserHistory.push(iosDownloadURL);
      return;
    }
    if (isAndroidDevice) {
      browserHistory.push(androidURL);
      return;
    }
  }
  browserHistory.push(redirectURL);
};

// Shows the Comarch migration screen for HU, DE, AT markets.
// Falls back to the provided action for all other markets.
export function handleComarchMigration(fallback) {
  return async (dispatch, getState) => {
    try {
      const isComarch = await isComarchMigrationEnabled(getState);
      if (isComarch) {
        return dispatch(
          showNotification({
            ...COMARCH_MIGRATION_NOTIFICATION,
            buttons: [
              {
                ...COMARCH_MIGRATION_NOTIFICATION.buttons[0],
                event: () => {
                  dispatch(sendAdobeAnalyticsEvent(adobeAnalyticTags.comarchMigration.migrate_button, 'tileClick'));
                  return redirectToComarchURL(getState, dispatch);
                },
              },
            ],
          })
        );
      } else {
        return fallback();
      }
    } catch {
      return fallback();
    }
  };
}

